import React from "react";
import "./Footer.scss";
import logo from "../../assests/logo.png";

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  return (
    <footer className="site-footer">
      <div className="site-footer__inner">
        <img src={logo} alt="Nagarro" className="site-footer__logo" />
        <p className="site-footer__copy">
          © {currentYear} Nagarro· All rights reserved.
              </p>
      </div>
    </footer>
  );
};

export default Footer;
